// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconArrowBackward = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'current',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.666 19 4 12m0 0 6.666-7M4 12h16',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconArrowBackward };
